export default __webpack_public_path__ + "static/media/copy.167f4292.svg";